import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Modal, ModalContentWrapper } from 'secondstep-components'

export const StyledModal = styled(Modal)`
  ${ModalContentWrapper} {
    box-sizing: border-box;
    width: 525px;
    overflow: auto;
    font-family: ${themeGet('font.molde.regular')};
    padding: 1.25rem;
  }
`
